import React from "react";

class NotesEditor extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      input: props.notes || "",
    };

    this.handleInputChange = this.handleInputChange.bind(this);
  }

  componentDidMount() {
    const { onChanged } = this.props;
    const { input } = this.state;

    if (onChanged) {
      onChanged(input);
    }
  }

  handleInputChange(e) {
    const { onChanged } = this.props;
    const input = e.target.value;

    if (onChanged) {
      onChanged(input);
    }

    this.setState({
      input,
    });
  }

  render() {
    const { input } = this.state;
    return (
      <textarea
        className="rounded border w-full border-blue-600 bg-yellow-100 px-2 py-1 text-sm"
        rows={6}
        autoFocus
        value={input}
        onChange={this.handleInputChange}
      ></textarea>
    );
  }
}

export default NotesEditor;
